import axios from '@/axios';

const RESOURCE_NAME = '/projects';

export default {
    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`);
    },

    getTasksCount(id) {
        return axios.get(`${RESOURCE_NAME}/get-tasks-count?id=${id}`);
    },

    getStatusesList() {
        return axios.get(`${RESOURCE_NAME}/get-statuses-list`)
    },

    getOptionsForFilter(id) {
        return axios.get(`${RESOURCE_NAME}/get-options-for-filter?id=${id}`);
    },

    getOptionsForWatchers(id) {
        return axios.get(`${RESOURCE_NAME}/get-options-for-watchers?id=${id}`);
    },

    getProjectEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    getNewProjectInfo() {
        return axios.get(`${RESOURCE_NAME}/get-new-project-info`)
    },

    save(id, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}`, data)
    },

    saveSubmitterFiles(id, fieldId, data) {
        return axios.post(`${RESOURCE_NAME}/save-submitter-files?id=${id}&field_id=${fieldId}`, data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
    },

    delete(id) {
        return axios.post(`${RESOURCE_NAME}/delete-project?id=${id}`)
    },
}
